'use strict';

var React = require('react');
var InfoChip = require('../../DesignSystem/DataDisplay/InfoChip/InfoChip.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var getInfoChipColor = function getInfoChipColor(color) {
  switch (color) {
    case 'primary':
      return 'primary';

    default:
      return 'default';
  }
};
/**
 * This is not the main `Chip` component. You are probably looking for `DesignSystem/DataDisplay/Chip/Chip.jsx` or `DesignSystem/DataDisplay/InfoChip/InfoChip.tsx`
 * @deprecated this component has been replaced by `InfoChip` and will be removed in the future
 */


var Chip = function Chip(_ref) {
  var color = _ref.color,
      label = _ref.label,
      className = _ref.className;
  return React__default["default"].createElement(InfoChip, {
    color: getInfoChipColor(color),
    label: label,
    className: className
  });
};

Chip.defaultProps = {
  color: 'default'
};

module.exports = Chip;
